import { BaseNode } from '../../elements';
class BasePipelineNode extends BaseNode {
    constructor() {
        super();
    }
    setModel(model) {
        super.setModel(model);
        if ('runAfterTasks' in model) {
            this.runAfterTasks = model.runAfterTasks;
        }
    }
    toModel() {
        return Object.assign(Object.assign({}, super.toModel()), { runAfterTasks: this.runAfterTasks, children: super.getAllChildren().map((c) => c.getId()) });
    }
}
export default BasePipelineNode;
//# sourceMappingURL=BasePipelineNode.js.map